import React from "react";
import AutoTyping from "react-auto-typing";
import { Dots } from "react-dot-patterns";

const OurApproach = () => {
  return (
    <div className="trackline-approach-wrapper">
      <div className="dots1">
        <Dots
          col={6}
          row={4}
          size={5}
          rotate={0}
          margin={8}
          color={"#f3792c"}
          item={null}
          style={{}}
          evenRowShift={10}
          // evenColoumnShift={20}
        />
      </div>
      <div className="dots2">
        <Dots
          col={3}
          row={4}
          size={5}
          rotate={0}
          margin={5}
          color={"#f3792c"}
          item={null}
          style={{}}
          evenRowShift={-20}
          // evenColoumnShift={20}
        />
      </div>
      <div className="section-title">
        <h1 className="title">
          Innovative, Flexible, and Secure: The Trackline Advantage
        </h1>
        <span className="subtitle" aria-hidden="true">
          <AutoTyping
            active // <boolean>
            textRef={"Our Approach"}
            writeSpeed={150} // <number>
            deleteSpeed={150} // <number>
            delayToWrite={1000} // <number>
            delayToDelete={2000}
          />
        </span>
      </div>
      <div className="approach-container">
        <div className="approach-box">
          <div className="approach-detail first">
            <div className="arrow"></div>
            <h4>Strategy</h4>
            <p>
              Helping you answer, "How can we simplify and optimize our asset
              management processes?"
            </p>
          </div>
        </div>
        <div className="approach-box">
          <div className="approach-detail second">
            <div className="arrow"></div>
            <h4>Design</h4>
            <p>
              We create intuitive, user-friendly interfaces that make asset
              tracking effortless.
            </p>
          </div>
        </div>
        <div className="approach-box">
          <div className="approach-detail third">
            <div className="arrow"></div>
            <h4>Development</h4>
            <p>
              Our development team builds secure, scalable software to ensure
              your asset management runs smoothly across all platforms.
            </p>
          </div>
        </div>
        <div className="approach-box">
          <div className="approach-detail forth">
            <div className="arrow"></div>
            <h4>Testing</h4>
            <p>
              Before deployment, we rigorously test every feature in real-world
              scenarios to ensure reliable performance. From tracking to
              maintenance alerts, our testing guarantees accuracy.
            </p>
          </div>
        </div>
        <div className="approach-box">
          <div className="approach-detail fifth">
            <div className="arrow"></div>
            <h4>Deployment</h4>
            <p>
              Implement Trackline efficiently, minimizing disruption to your
              current workflows.
            </p>
          </div>
        </div>
        <div className="approach-box">
          <div className="approach-detail sixth">
            <div className="arrow"></div>
            <h4>Maintenance</h4>
            <p>
              We offer ongoing support to keep your asset management system
              running seamlessly, providing updates and troubleshooting as
              required.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OurApproach;
